import { useContext } from 'react';
import { AutomationPageV2StoreContext } from './contextStore';

export function useAutomationV2Store() {
	const ctx = useContext(AutomationPageV2StoreContext);
	if (ctx === null) {
		throw new Error(
			'useAutomationV2Store was called outside of AutomationPageV2StoreContext'
		);
	}
	return ctx;
}
